// OCT-7340: TreatyApp: User Management — add an Action History view of admin activity - Frontend : ashish.atwal@resolutionlife.com
// Maps the human-readable action labels produced by the backend (OCT-7301) to
// Chakra colour schemes so the Action History table is easy to scan. The action
// labels are plain strings from the backend; any unrecognised label falls back
// to a neutral grey.

// The exact action labels emitted by the backend (OCT-7301 AdminActionType).
export const ACTION_LABELS = [
  'Added user',
  'Changed roles',
  'Changed email notifications',
  'Blocked user',
  'Unblocked user',
  'Reset MFA',
  'Approved PII',
  'Created folder',
  'Archived file',
] as const;

const actionColorSchemeMap: Record<string, string> = {
  'Added user': 'green',
  'Changed roles': 'blue',
  'Changed email notifications': 'purple',
  'Blocked user': 'red',
  'Unblocked user': 'orange',
  'Reset MFA': 'yellow',
  'Approved PII': 'teal',
  'Created folder': 'gray',
  'Archived file': 'gray',
};

/**
 * Returns the Chakra colour scheme for a given action label, defaulting to a
 * neutral grey for any label not explicitly mapped.
 */
export const getActionColorScheme = (actionType: string): string =>
  actionColorSchemeMap[actionType] ?? 'gray';
